import $ from 'jquery';

const toggleModal = () => {
  $('body').toggleClass('overflow-hidden w-full h-full');
  $('#offer').toggleClass('hidden');
};

// Otevření modalu
$('.offer-btn').on('click', toggleModal);

// Zavření modalu
$('#offer-close').on('click', toggleModal);